import type { FC } from "react";
import React from "react";
import {
  Body,
  Box,
  Flex,
  Image,
  Pill,
} from "@edreamsodigeo/prisma-design-system";

import type { FlightsBannerItemProps } from "~/components/acquisition/RefundableFlightsBanner/contracts";

const FlightsBannerItem: FC<FlightsBannerItemProps> = ({
  imageAlt,
  imageLink,
  pill,
  text,
}) => {
  return (
    <Flex
      flexDirection={"column"}
      alignItems={"center"}
      width={"30%"}
      px={"base"}
    >
      <Image
        src={imageLink}
        alt={imageAlt}
        sx={{ width: "48px", height: "48px" }}
      />
      <Box mt={"base"}>
        <Body type={"small"} textAlign={"center"} color={"neutral.80"}>
          {text}
        </Body>
      </Box>
      {pill && (
        <Box mt={"small"}>
          <Pill type={"promotional"} rounded>
            {pill}
          </Pill>
        </Box>
      )}
    </Flex>
  );
};

export default FlightsBannerItem;
